// extracted by mini-css-extract-plugin
export default {"tableBlock":"Table_tableBlock__j3KsU","bgGrey":"Table_bgGrey__kXltt","btn":"Table_btn__UXCfO"};